import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IonContent, IonIcon } from '@ionic/angular/standalone';

import { addIcons } from 'ionicons';
import { chevronForward, cubeOutline, listOutline, personOutline } from 'ionicons/icons';

import { isFeatureEnabled } from '@core/config/feature-flags';

import { AppHeaderComponent } from '@infrastructure/components';

@Component({
  selector: 'app-home',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonContent, IonIcon, AppHeaderComponent, RouterLink],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  protected readonly materialsEnabled = isFeatureEnabled('materials');

  constructor() {
    addIcons({ chevronForward, cubeOutline, listOutline, personOutline });
  }
}
